export const SET_OPENAISTATUS = "setOpenAIStatus"
export const SET_SHORTID = "setShortId"
export const SET_PERSONA = "setPersona"
